// react core
import { useContext, useState, useCallback, useEffect } from "react";

// qr codes
import { QRCode } from "react-qrcode-logo";

// material design
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
// import Drawer from "@mui/material/Drawer";
import Typography from "@mui/material/Typography";

import Dialog from "@mui/material/Dialog";
// import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";

// fonts and icons
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalculator as iconNumeric } from "@fortawesome/pro-duotone-svg-icons";
import { faCommentDollar as iconDescription } from "@fortawesome/pro-duotone-svg-icons";
// import { faBasketShopping as iconProduct } from "@fortawesome/pro-duotone-svg-icons";
import { faShoppingCart as iconCart } from "@fortawesome/pro-duotone-svg-icons";
import { faTrashAlt as iconDelete } from "@fortawesome/pro-duotone-svg-icons";
import { faPlus as iconIncrement } from "@fortawesome/pro-duotone-svg-icons";
import { faMinus as iconDecrement } from "@fortawesome/pro-duotone-svg-icons";
import { faChevronSquareRight as iconCheckout } from "@fortawesome/pro-solid-svg-icons";
import { faTimes as iconClose } from "@fortawesome/pro-thin-svg-icons";

// entzy config models and components
import configEntzy from "components/config/ConfigEntzy";
import { MainContext } from "components/main/MainContext";
import { EventContext } from "components/event/EventContext";
import {
  ActionButton,
  MoreButton,
  CopyButton,
} from "components/utils/common/CommonButtons";
import {
  ActionLoader,
  ActionCheck,
} from "components/utils/common/CommonLoaders";
import InputForm from "components/input/InputForm";
import { TextTag } from "components/utils/common/CommonTags";
import { parseEntzyUrlComponents } from "services/tools";
import { createGeoCurrencyItemByCode } from "models/geo";

// entzy assets
import iconQrCode from "assets/logos/entzy-dark-card.png";
import logoFallback from "assets/banners/entzy-arty.png";

// entzy hooks
import { useMediaImage } from "hooks/media/mediaImage";

function PayProducts(props) {
  const mainContext = useContext(MainContext);
  const eventContext = useContext(EventContext);
  const user = props.user;
  const recipientType = props.recipientType;
  const recipientName = props.recipientName;
  const defaultCurrency = props.defaultCurrency;
  const defaultAmount = props.defaultAmount;
  const defaultDescription = props.defaultDescription;
  const isEventuator = recipientType === "eventuator";
  const productOrder = props.productOrder;
  const startProductOrder = props.startProductOrder;
  // const clearProductOrder = props.clearProductOrder;
  const handleHidePayForm = props.handleHidePayForm;
  const handleCheckout = props.handleCheckout;
  const [loading, setLoading] = useState(false);
  const [loadingMore, setLoadingMore] = useState(false);
  const [hydrated, setHydrated] = useState(false);
  const [showProductForm, setShowProductForm] = useState(false);
  const [productCounts, setProductCounts] = useState({});
  const [printView, setPrintView] = useState(false);
  const [dialog, setDialog] = useState({
    visible: false,
  });

  const productsActive = user.connected ? user.status.payment_set : true;
  const productsEditingActive = user.connected && user.status.payout_set;

  // configure qr code core settings
  // const qrParentValue = isEventuator
  //   ? `${parseEntzyUrlComponents(recipientName).absoluteUrl}`
  //   : `${configEntzy.APP_URL}/@/${recipientName}`;
  const qrValue = isEventuator
    ? `${parseEntzyUrlComponents(recipientName).absoluteUrl}/store`
    : `${configEntzy.APP_URL}/pay/@/${recipientName}`;
  const qrLogo = iconQrCode;

  // const getProductCart = () => {
  //   const productCart = [];
  //   for (const [productId, productCount] of Object.entries(productCounts)) {
  //     if (productCount > 0) {
  //       productCart.push({
  //         ProductId: productId,
  //         ProductDescription: mainContext.state.productList.data.items.filter(
  //           (obj) => obj.ProductId === productId
  //         )[0].Description,
  //         ProductCount: productCount,
  //       });
  //     }
  //   }
  //   return productCart;
  // };
  const getProductCartTotal = () => {
    let productCartTotal = 0;
    for (const [productId, productCount] of Object.entries(productCounts)) {
      if (productCount > 0) {
        const productAmount = mainContext.state.productList.data.items.filter(
          (obj) => obj.ProductId === productId,
        )[0].Amount;
        productCartTotal += productAmount * productCount;
      }
    }
    return productCartTotal / 100;
  };
  const getProductCartCurrency = () => {
    let productCartCurrency = null;
    for (const [productId, productCount] of Object.entries(productCounts)) {
      if (productCount > 0) {
        productCartCurrency = mainContext.state.productList.data.items.filter(
          (obj) => obj.ProductId === productId,
        )[0].Currency;
        break;
      }
    }
    return productCartCurrency;
  };
  const getProductCartDescription = () => {
    let productCartDescription = "";
    for (const [productId, productCount] of Object.entries(productCounts)) {
      if (productCount > 0) {
        productCartDescription += `${productCount} x ${
          mainContext.state.productList.data.items.filter(
            (obj) => obj.ProductId === productId,
          )[0].Description
        }. `;
      }
    }
    return productCartDescription;
  };
  const getProductCount = (productId) => {
    if (productCounts[productId]) {
      return productCounts[productId];
    } else {
      return 0;
    }
  };

  const handleIncrementProductCount = (productId) => {
    // check product is the same currency as the cart
    const cartCurrency = getProductCartCurrency();
    const productCurrency = mainContext.state.productList.data.items.filter(
      (obj) => obj.ProductId === productId,
    )[0].Currency;
    if (cartCurrency && cartCurrency !== productCurrency) {
      mainContext.updateAlert({
        alert: true,
        message: "Products added to each checkout must be the same currency",
      });
      return;
    }
    // add to cart
    const productCountsCopy = { ...productCounts };
    if (productCountsCopy[productId]) {
      productCountsCopy[productId] += 1;
    } else {
      productCountsCopy[productId] = 1;
    }
    setProductCounts(productCountsCopy);
  };
  const handleDecrementProductCount = (productId) => {
    const productCountsCopy = { ...productCounts };
    if (productCountsCopy[productId]) {
      productCountsCopy[productId] -= 1;
    } else {
      productCountsCopy[productId] = 0;
    }
    setProductCounts(productCountsCopy);
  };
  // const handleResetProductCount = (productId) => {
  //   const productCountsCopy = { ...productCounts };
  //   productCountsCopy[productId] = 0;
  //   setProductCounts(productCountsCopy);
  // };
  const handleShowProductForm = () => {
    handleHidePayForm(!showProductForm);
    setShowProductForm(!showProductForm);
  };

  const handleActionCallback = async (data) => {
    const productCurrency = data.filter(
      (obj) => obj.id === "product-currency",
    )[0].value;
    const productAmount = data.filter((obj) => obj.id === "product-amount")[0]
      .value;
    const productDescription = data.filter(
      (obj) => obj.id === "product-description",
    )[0].value;
    if (user.connected) {
      if (
        productCurrency &&
        productAmount &&
        !isNaN(productAmount) &&
        productAmount > 0 &&
        productDescription.length > 0
      ) {
        const productAmountInt = Math.round(productAmount * 100);
        const response = await mainContext.prepareCreateProduct({
          Url: isEventuator ? recipientName : null,
          Name: isEventuator ? null : recipientName,
          List: configEntzy.PRODUCT_LIST_DEFAULT,
          Category: configEntzy.PRODUCT_CATEGORY_DEFAULT,
          Currency: productCurrency.code.long,
          Amount: productAmountInt,
          Description: productDescription,
        });
        if (response.alert) {
          return response;
        }
        mainContext.createProduct(response.data);
        return {};
      } else {
        return {
          alert: true,
          message: "Select a currency with a valid amount and description",
        };
      }
    } else {
      return {
        alert: true,
        message: "Connect to manage product lists",
      };
    }
  };

  const handlePullProductList = async (more) => {
    if (more) {
      setLoadingMore(true);
    } else {
      setLoading(true);
    }
    let response;
    response = await mainContext.preparePullProductList({
      Url: isEventuator ? recipientName : null, // send url if eventuator
      Name: isEventuator ? null : recipientName, // send user name if not eventuator
      List: configEntzy.PRODUCT_LIST_DEFAULT,
      Category: configEntzy.PRODUCT_CATEGORY_DEFAULT,
      nextToken: mainContext.state.productList.data.nextToken,
      more,
    });
    setLoading(false);
    setLoadingMore(false);
    if (response.alert) {
      mainContext.updateAlert(response);
    } else {
      mainContext.pullProductList({
        data: response.data,
        more,
      });
    }
  };
  const cbHandlePullProductList = useCallback(handlePullProductList, [
    mainContext,
    isEventuator,
    recipientName,
  ]);

  const handleConfirmDeleteProduct = async (event, confirm, productId) => {
    if (confirm === true) {
      setDialog({ visible: false });
      handleDeleteProduct(productId);
    } else if (confirm === false) {
      setDialog({ visible: false });
    } else {
      setDialog({
        visible: true,
        title: "Confirm Delete Product",
        description: "Are you sure you want to delete this item?",
        cancel: (e) => handleConfirmDeleteProduct(e, false, productId),
        confirm: (e) => handleConfirmDeleteProduct(e, true, productId),
      });
    }
  };

  const handleDeleteProduct = async (productId) => {
    setLoading(true);
    const response = await mainContext.prepareDeleteProduct({
      Url: isEventuator ? recipientName : null,
      Name: isEventuator ? null : recipientName,
      ProductId: productId,
    });
    setLoading(false);
    if (response.alert) {
      mainContext.updateAlert(response);
    } else {
      mainContext.deleteProduct({
        data: response.data,
      });
    }
  };

  const handleSwitchPrintView = () => {
    setPrintView(!printView);
  };

  // pull messages on page load
  // on fresh hydrate or recipient change
  useEffect(() => {
    if (
      !hydrated &&
      !mainContext.state.productList.hydrated &&
      !mainContext.state.alert.show
    ) {
      setHydrated(true);
      cbHandlePullProductList(false);
    }
    if (
      mainContext.state.productList.hydrated &&
      !mainContext.state.productList.listId.startsWith(
        recipientType + ":" + recipientName,
      ) &&
      !mainContext.state.alert.show
    ) {
      setHydrated(true);
      cbHandlePullProductList(false);
    }
  }, [
    hydrated,
    mainContext.state.productList.hydrated,
    mainContext.state.productList.listId,
    mainContext.state.alert.show,
    recipientName,
    recipientType,
    cbHandlePullProductList,
  ]);

  // load recipient logo image
  // detect only via existing loaded images
  const eventLogo = useMediaImage(
    recipientType === "eventuator"
      ? eventContext && eventContext.state.event.hydrated
        ? {
            user: user,
            context: mainContext,
            image: {
              id: "event:logo:" + eventContext.state.event.data.EventId,
              key: eventContext.state.event.data.Logo,
            },
          }
        : null
      : null,
  );
  const memberDetails =
    recipientType === "member"
      ? mainContext.state.interaction.users.find(
          (member) => member.name === recipientName,
        )
      : null;
  const memberLogo =
    memberDetails && memberDetails.avatar?.images?.lg?.data
      ? memberDetails.avatar.images.lg.data
      : null;
  const payLogo =
    recipientType === "eventuator"
      ? eventLogo.ready && eventLogo?.images?.lg?.data
        ? eventLogo.images.lg.data
        : logoFallback
      : recipientType === "member"
        ? memberLogo
          ? memberLogo
          : logoFallback
        : logoFallback;

  return (
    <Box
      className="box-default"
      sx={{
        pt: configEntzy.APP_SPACING_MD2X,
        px: configEntzy.APP_SPACING_MD,
      }}
    >
      <Box className="box-default" hidden={printView}>
        <Box
          className="box-default bg-black-t50"
          sx={{
            p: configEntzy.APP_SPACING_MD,
            mb: configEntzy.APP_SPACING_MD,
            borderRadius: configEntzy.BORDER_SIZE_XL,
          }}
        >
          <Box className="box-default">
            <Typography variant="h4" color="primary">
              Product Menu
            </Typography>
          </Box>

          {mainContext.state.productList.hydrated &&
            mainContext.state.productList.data.itemsCount > 0 && (
              <Box className="box-default" sx={{ color: "white" }}>
                {showProductForm ? (
                  <Box className="box-default">
                    <Typography
                      variant="subtitle2"
                      sx={{
                        mt: configEntzy.APP_SPACING_SM,
                      }}
                    >
                      Edit your product list
                    </Typography>
                  </Box>
                ) : productOrder ? (
                  <Box className="box-default">
                    <Typography
                      variant="subtitle2"
                      sx={{
                        mt: configEntzy.APP_SPACING_SM,
                      }}
                    >
                      {productsActive
                        ? "Add products & checkout when ready"
                        : "Add payment details to activate menu"}
                    </Typography>
                  </Box>
                ) : (
                  <Box className="box-default">
                    {/* <Typography
                    variant="subtitle2"
                    sx={{
                      mt: configEntzy.APP_SPACING_SM,
                    }}
                  >
                    Products on sale by {recipientType}{" "}
                    {recipientName.replace(/\./g, "/")}
                  </Typography> */}
                  </Box>
                )}
              </Box>
            )}
          {mainContext.state.productList.hydrated &&
            mainContext.state.productList.data.DataManager && (
              <Box
                className="box-default"
                sx={{
                  mt: configEntzy.APP_SPACING_MD,
                }}
                hidden={productOrder}
              >
                <ActionButton
                  size="small"
                  text={showProductForm ? "Hide X" : "Manage Products"}
                  variant="contained"
                  color="night"
                  border={true}
                  onClick={handleShowProductForm}
                />
              </Box>
            )}

          {showProductForm && (
            <Box
              className="box-default"
              sx={{
                pt: configEntzy.APP_SPACING_MD,
                // px: configEntzy.APP_SPACING_MD,
                // mb: configEntzy.APP_SPACING_LG,
              }}
            >
              <InputForm
                navigate={props.navigate}
                fields={[
                  {
                    id: "product-currency",
                    type: "selector-currency",
                    label: "Product currency",
                    value: defaultCurrency
                      ? createGeoCurrencyItemByCode({
                          longCode: defaultCurrency,
                        })
                      : null,
                    required: true,
                  },
                  {
                    id: "product-amount",
                    type: "text-standard",
                    label: "Product cost",
                    placeholder: "0.00",
                    value: defaultAmount ? defaultAmount : "",
                    numeric: true,
                    required: true,
                    startAdornment: (
                      <FontAwesomeIcon icon={iconNumeric} transform="grow-10" />
                    ),
                  },
                  {
                    id: "product-description",
                    type: "text-standard",
                    label: "Product description",
                    placeholder: "Description",
                    value: defaultDescription ? defaultDescription : "",
                    required: false,
                    maxLength: 50,
                    startAdornment: (
                      <FontAwesomeIcon
                        icon={iconDescription}
                        transform="grow-10"
                      />
                    ),
                  },
                ]}
                submitText="Add Product to List"
                submitBoxSx={{}}
                disabledSubmit={!productsEditingActive}
                disabledTitle="Add Income Account"
                disabledText="Tap here to activate your income account and you can start selling products"
                disabledClick={
                  !user.connected
                    ? props.drawerConnectToggle
                    : () => {
                        props.menuSelectById("settings-income-bank");
                        mainContext.setPayDirectViewer({
                          open: false,
                        });
                      }
                }
                callback={handleActionCallback}
              />
            </Box>
          )}
        </Box>
        <Box
          className="box-default"
          // sx={{
          //   p: configEntzy.APP_SPACING_MD,
          // }}
        >
          {loading || !mainContext.state.productList.hydrated ? (
            <Box
              className="box-default"
              sx={{
                pt: configEntzy.APP_SPACING_LG,
              }}
            >
              <ActionLoader />
            </Box>
          ) : mainContext.state.productList.data.itemsCount > 0 ? (
            <Box className="box-default">
              {/* <Box
              className="box-default"
              sx={{
                pb: configEntzy.APP_SPACING_MD2X,
              }}
            >
              <Typography variant="h6" className="upper-case">
                <span>Total:</span>
                <span>&nbsp;&nbsp;</span>
                {getProductCartCurrency()}
                <span>&nbsp;</span>
                {getProductCartTotal().toFixed(2)}
              </Typography>
            </Box> */}
              <Box
                className="box-default bg-black-t90 shadow-orange-glow"
                sx={{
                  p: configEntzy.APP_SPACING_MD,
                  mb: configEntzy.APP_SPACING_MD,
                  borderRadius: configEntzy.BORDER_SIZE_XL,
                }}
                hidden={!productsActive || !productOrder}
              >
                <Box className="box-default">
                  <ActionButton
                    variant="contained"
                    color="primary"
                    text={
                      <span>
                        <span>&nbsp;</span>
                        <span>Checkout</span>
                        <span>&nbsp;</span>
                        <span>
                          (
                          {getProductCartCurrency() && (
                            <span>{getProductCartCurrency()}&nbsp;</span>
                          )}
                          {getProductCartTotal().toFixed(2)})
                        </span>
                        <span>&nbsp;</span>
                      </span>
                    }
                    disabled={!productsActive || getProductCartTotal() === 0}
                    onClick={
                      productsActive
                        ? () => {
                            handleCheckout({
                              currencyCode: getProductCartCurrency(),
                              amount: getProductCartTotal(),
                              description: getProductCartDescription(),
                            });
                          }
                        : undefined
                    }
                    endIcon={<FontAwesomeIcon icon={iconCheckout} fixedWidth />}
                  />
                </Box>
                <Box
                  className="box-default"
                  sx={{
                    pt: configEntzy.APP_SPACING_MD,
                  }}
                >
                  <TextTag
                    size="md"
                    text={
                      <span>
                        <span>&nbsp;</span>
                        <span>Reset Cart</span>
                        <span>&nbsp;</span>
                      </span>
                    }
                    bgColor="white"
                    color="black"
                    rounded={true}
                    onClick={() => {
                      setProductCounts({});
                      // clearProductOrder();
                    }}
                  />
                </Box>
                {/* <TextTag
                  text={
                    <span>
                      <span>&nbsp;</span>
                      <span>Checkout</span>
                      <span>&nbsp;&nbsp;</span>
                      <FontAwesomeIcon icon={iconCheckout} />
                      <span>&nbsp;</span>
                    </span>
                  }
                  size="lg"
                  bgColor={productsActive ? "primary.dark" : "lightgray"}
                  color={productsActive ? "black" : "gray"}
                  rounded={true}
                  shadow={productsActive}
                  onClick={
                    productsActive
                      ? () => {
                          handleStagePayment(
                            getProductCartCurrency(),
                            getProductCartTotal(),
                            getProductCartDescription()
                          );
                        }
                      : undefined
                  }
                /> */}
              </Box>
              {/* {getProductCart().map((item, index) => {
              return (
                <Box
                  key={item.ProductId}
                  className="box-default"
                  sx={{
                    pb: configEntzy.APP_SPACING_MD,
                  }}
                >
                  <Typography variant="body1" className="text-default">
                    {item.ProductDescription} {item.ProductCount}
                  </Typography>
                </Box>
              );
            })} */}
              {mainContext.state.productList.data.items.map((item, index) => {
                const productCurrency = item.Currency;
                const productCount = getProductCount(item.ProductId);
                const productPrice = item.Amount / 100;
                const productAmount = (item.Amount * productCount) / 100;
                const productDescription = item.Description;
                return (
                  <Box
                    className="box-default"
                    sx={{
                      pb: configEntzy.APP_SPACING_MD,
                    }}
                    key={item.ProductId}
                  >
                    <Box
                      className="box-default bg-black-t50"
                      sx={{
                        p: configEntzy.APP_SPACING_MD,
                        borderRadius: configEntzy.BORDER_SIZE_XL,
                      }}
                    >
                      <Box
                        className="box-default text-left"
                        sx={{
                          p: configEntzy.APP_SPACING_XS3X,
                        }}
                      >
                        <Typography
                          variant="h6"
                          color="white"
                          className="upper-case"
                        >
                          {productDescription}
                        </Typography>
                        <Typography
                          variant="subtitle2"
                          color="white"
                          sx={{
                            mt: configEntzy.APP_SPACING_SM,
                          }}
                        >
                          <span>
                            <FontAwesomeIcon icon={iconCart} />
                            <span>&nbsp;&nbsp;</span>
                            <span>{productCurrency.toUpperCase()}</span>
                            <span>&nbsp;</span>
                            <span>{productPrice.toFixed(2)}</span>
                          </span>
                        </Typography>
                        <Typography
                          variant="subtitle2"
                          color={productCount > 0 ? "darkorange" : "inherit"}
                        >
                          <span>
                            <span>Cart subtotal: </span>
                            <span>&nbsp;&nbsp;</span>
                            <span>{productCurrency.toUpperCase()}</span>
                            <span>&nbsp;</span>
                            <span>{productAmount.toFixed(2)}</span>
                          </span>
                          {productsActive &&
                            !productOrder &&
                            !showProductForm && (
                              <span
                                className="text-sit-right bg-orange rounded action-pointer"
                                onClick={() => {
                                  if (productsActive && !productOrder) {
                                    startProductOrder();
                                  }
                                }}
                                style={{ color: "black" }}
                              >
                                &nbsp;&nbsp;ADD&nbsp;&nbsp;
                              </span>
                            )}
                        </Typography>
                      </Box>
                      <Box className="box-default">
                        {productsActive && productOrder && (
                          <Box
                            className="box-inline left"
                            sx={{
                              pt: configEntzy.APP_SPACING_MD2X,
                            }}
                          >
                            <TextTag
                              text={
                                <span>
                                  <FontAwesomeIcon icon={iconDecrement} />
                                </span>
                              }
                              size="lg"
                              bgColor="primary.main"
                              color="black"
                              noMask={true}
                              shadow={true}
                              rounded={true}
                              onClick={() => {
                                handleDecrementProductCount(item.ProductId);
                              }}
                            />
                            <TextTag
                              text={
                                <span>
                                  <span>&nbsp;&nbsp;</span>
                                  {productCount}
                                  <span>&nbsp;&nbsp;</span>
                                </span>
                              }
                              size="lg"
                              bgColor={
                                productCount > 0
                                  ? "secondary.main"
                                  : "dusk.dark"
                              }
                              color={productCount > 0 ? "black" : "white"}
                              noMask={true}
                              shadow={true}
                              rounded={true}
                            />
                            <TextTag
                              text={
                                <span>
                                  <FontAwesomeIcon icon={iconIncrement} />
                                </span>
                              }
                              size="lg"
                              bgColor="primary.main"
                              color="black"
                              noMask={true}
                              shadow={true}
                              rounded={true}
                              onClick={() => {
                                handleIncrementProductCount(item.ProductId);
                              }}
                            />
                          </Box>
                        )}
                        {showProductForm && (
                          <Box
                            className="box-inline left"
                            sx={{
                              pt: configEntzy.APP_SPACING_MD2X,
                            }}
                          >
                            {mainContext.state.productList.data.DataManager ? (
                              <TextTag
                                text={
                                  <span>
                                    {/* <span>Remove</span>
                                  <span>&nbsp;&nbsp;</span> */}
                                    <FontAwesomeIcon icon={iconDelete} />
                                  </span>
                                }
                                size="lg"
                                onClick={() => {
                                  handleConfirmDeleteProduct(
                                    null,
                                    null,
                                    item.ProductId,
                                  );
                                }}
                                bgColor="danger.light"
                                color="black"
                                rounded={true}
                                shadow={true}
                              />
                            ) : (
                              <> </>
                              // <TextTag
                              //   text={
                              //     <span>
                              //       <span>&nbsp;&nbsp;</span>
                              //       <FontAwesomeIcon
                              //         icon={iconProduct}
                              //         fixedWidth
                              //       />
                              //       <span>&nbsp;&nbsp;</span>
                              //     </span>
                              //   }
                              //   size="lg"
                              //   rounded={true}
                              //   shadow={productsActive}
                              //   onClick={
                              //     productsActive
                              //       ? () => {
                              //           handleProductCart(item.ProductId);
                              //         }
                              //       : undefined
                              //   }
                              // />
                            )}
                          </Box>
                        )}
                      </Box>
                    </Box>
                    {productOrder && !productsActive && (
                      <Box
                        className="box-default text-right"
                        sx={{
                          pt: configEntzy.APP_SPACING_MD,
                        }}
                      >
                        <Typography variant="body1">
                          <em>Add payment details to activate</em>
                        </Typography>
                      </Box>
                    )}
                    <Box className="box-default">
                      <ActionCheck
                        dialog={dialog.visible}
                        title={dialog.title}
                        description={dialog.description}
                        cancel={dialog.cancel}
                        confirm={dialog.confirm}
                      />
                    </Box>
                  </Box>
                );
              })}

              {mainContext.state.productList.data.nextToken && (
                <Box
                  className="box-default"
                  sx={{ mt: configEntzy.APP_SPACING_LG }}
                >
                  {user.connected ? (
                    <MoreButton
                      variant="contained"
                      size="large"
                      type="button"
                      color="bright"
                      text="More"
                      loading={loadingMore}
                      onClick={() => handlePullProductList(true)}
                    />
                  ) : (
                    <MoreButton
                      variant="contained"
                      size="large"
                      type="button"
                      color="bright"
                      text="Connect for more messages..."
                      disabled={true}
                    />
                  )}
                </Box>
              )}
            </Box>
          ) : (
            <Box
              className="box-default bg-black-t50 text-paragraph"
              sx={{
                py: configEntzy.APP_SPACING_XL,
                px: configEntzy.APP_SPACING_MD2X,
                borderRadius: configEntzy.BORDER_SIZE_XL,
              }}
            >
              <Typography variant="subtitle2" color="white">
                This {recipientType} has no active products
              </Typography>
              <Typography
                variant="subtitle1"
                sx={{
                  mt: configEntzy.APP_SPACING_SM,
                }}
              >
                Direct payments can still be made via custom payment
              </Typography>
            </Box>
          )}
        </Box>
        <Box className="box-default">
          <Box
            className="box-default"
            sx={{
              pt: configEntzy.APP_SPACING_XL,
            }}
          >
            <Typography variant="subtitle2" color="primary">
              <FontAwesomeIcon icon={iconCart} size="3x" />
            </Typography>
            <Typography
              variant="h6"
              color="primary"
              sx={{
                mt: configEntzy.APP_SPACING_MD,
              }}
            >
              <span>Eventuator Store Link</span>
            </Typography>
          </Box>
          <Box
            className="box-default bg-black-t75 shadow-dark"
            sx={{
              mt: configEntzy.APP_SPACING_MD2X,
              py: configEntzy.APP_SPACING_MD,
              borderRadius: configEntzy.BORDER_SIZE_XL,
            }}
          >
            <Box
              className="box-inline"
              sx={{
                width: configEntzy.QR_CODE_SIZE_MD,
                height: configEntzy.QR_CODE_SIZE_MD,
                backgroundColor: "transparent",
                borderRadius: configEntzy.BORDER_SIZE_LG,
                overflow: "hidden",
              }}
            >
              <QRCode
                value={qrValue}
                ecLevel="H"
                size={configEntzy.QR_CODE_SIZE_MD - 20}
                bgColor="white"
                fgColor="purple"
                quietZone={10}
                logoImage={qrLogo}
                logoWidth={configEntzy.QR_CODE_SIZE_MD / 4}
                logoHeight={configEntzy.QR_CODE_SIZE_MD / 4}
                logoOpacity={0.8}
                logoPadding={5}
                logoPaddingStyle="square"
                qrStyle="dots"
                eyeRadius={10}
                removeQrCodeBehindLogo={true}
              />
            </Box>
          </Box>
          <Box
            className="box-default bg-black-t50"
            sx={{
              mt: configEntzy.APP_SPACING_MD,
              borderRadius: configEntzy.BORDER_SIZE_XL,
            }}
          >
            <CopyButton text={qrValue} color="white" />
          </Box>
          <Box
            className="box-default"
            sx={{
              pt: configEntzy.APP_SPACING_HL,
              pb: configEntzy.APP_SPACING_HL,
            }}
          >
            <TextTag
              text={printView ? "Close X" : "Print View"}
              size="md"
              bgColor="black"
              color="white"
              rounded={true}
              shadow={true}
              edges={true}
              noMask={true}
              onClick={handleSwitchPrintView}
            />
          </Box>
        </Box>
      </Box>

      {/* <Drawer anchor="bottom" open={printView} onClose={handleSwitchPrintView}> */}

      <Dialog
        open={printView}
        onClose={handleSwitchPrintView}
        fullScreen
        scroll="paper"
      >
        <DialogContent
          className="print-root"
          sx={{
            overflow: "visible",
            height: "auto",
          }}
        >
          <Box
            className="box-default bg-white"
            sx={{
              p: configEntzy.APP_SPACING_MD,
            }}
          >
            <Container maxWidth="lg" disableGutters>
              <Box
                className="box-default text-right print-close"
                sx={{
                  pb: configEntzy.APP_SPACING_MD,
                }}
              >
                <Typography variant="h3" color="black">
                  <span
                    className="action-pointer"
                    onClick={handleSwitchPrintView}
                  >
                    <FontAwesomeIcon icon={iconClose} />
                  </span>
                </Typography>
              </Box>
              <Box className="box-default relative">
                <Box
                  className="box-default"
                  sx={{
                    "&::before": {
                      content: `''`,
                      position: "absolute",
                      top: 0,
                      left: 0,
                      width: "100%",
                      height: "100%",
                      backgroundImage: "url(" + payLogo + ")",
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                      backgroundRepeat: "repeat-y",
                      opacity: 0.5,
                      border: "1px solid black",
                      borderRadius: configEntzy.BORDER_SIZE_XL,
                    },
                  }}
                >
                  <Box
                    className="box-default"
                    sx={{
                      pt: configEntzy.APP_SPACING_HL,
                      pb: configEntzy.APP_SPACING_HL,
                    }}
                  >
                    <Box
                      className="box-inline relative bg-black-t90"
                      sx={{
                        py: configEntzy.APP_SPACING_SM,
                        px: configEntzy.APP_SPACING_MD,
                        borderRadius: configEntzy.BORDER_SIZE_XL,
                        color: "white",
                        zIndex: 1,
                      }}
                    >
                      <Typography variant="h6" color="primary">
                        Scan to Pay
                      </Typography>
                      <Typography variant="subtitle2">{qrValue}</Typography>
                    </Box>
                  </Box>
                </Box>
              </Box>
              <Box
                className="box-default bg-black-t75"
                sx={{
                  mt: configEntzy.APP_SPACING_MD,
                  p: configEntzy.APP_SPACING_MD,
                  borderRadius: configEntzy.BORDER_SIZE_XL,
                  border: "1px solid black",
                }}
              >
                <Box
                  className="box-inline bg-black-t90 shadow-purple-glow"
                  sx={{
                    width: configEntzy.QR_CODE_SIZE_MD,
                    height: configEntzy.QR_CODE_SIZE_MD,
                    backgroundColor: "transparent",
                    borderRadius: configEntzy.BORDER_SIZE_XL,
                    overflow: "hidden",
                  }}
                >
                  <QRCode
                    value={qrValue}
                    ecLevel="H"
                    size={configEntzy.QR_CODE_SIZE_MD - 20}
                    bgColor="white"
                    fgColor="purple"
                    quietZone={10}
                    logoImage={qrLogo}
                    logoWidth={configEntzy.QR_CODE_SIZE_MD / 4}
                    logoHeight={configEntzy.QR_CODE_SIZE_MD / 4}
                    logoOpacity={0.8}
                    logoPadding={5}
                    logoPaddingStyle="square"
                    qrStyle="dots"
                    eyeRadius={10}
                    removeQrCodeBehindLogo={true}
                  />
                </Box>
              </Box>
              <Box
                className="box-default"
                sx={{
                  pt: configEntzy.APP_SPACING_MD,
                }}
              >
                {mainContext.state.productList.data.items.map((item, index) => {
                  const productCurrency = item.Currency;
                  const productPrice = item.Amount / 100;
                  const productDescription = item.Description;
                  return (
                    <Box
                      className="box-default"
                      sx={{
                        pb: configEntzy.APP_SPACING_MD,
                      }}
                      key={item.ProductId}
                    >
                      <Box
                        className="box-default upper-case"
                        sx={{
                          p: configEntzy.APP_SPACING_MD,
                          borderRadius: configEntzy.BORDER_SIZE_XL,
                          border: "1px solid black",
                          color: "black",
                        }}
                      >
                        <Box
                          className="box-default q3-width text-left"
                          sx={{
                            p: configEntzy.APP_SPACING_SM,
                          }}
                        >
                          <Typography variant="h6">
                            {productDescription}
                          </Typography>
                        </Box>
                        <Box
                          className="box-default quarter-width text-right"
                          sx={{
                            p: configEntzy.APP_SPACING_SM,
                          }}
                        >
                          <Typography variant="h6">
                            <span>
                              <span>{productCurrency.toUpperCase()}</span>
                              <span>&nbsp;</span>
                              <span>{productPrice.toFixed(2)}</span>
                            </span>
                          </Typography>
                        </Box>
                      </Box>
                    </Box>
                  );
                })}
              </Box>
              {mainContext.state.productList.data.itemsCount === 0 && (
                <Box
                  className="box-default bg-black-t75 text-paragraph"
                  sx={{
                    py: configEntzy.APP_SPACING_XL,
                    px: configEntzy.APP_SPACING_MD2X,
                    borderRadius: configEntzy.BORDER_SIZE_XL,
                  }}
                >
                  <Typography variant="subtitle2" color="white">
                    No active products
                  </Typography>
                  <Typography variant="subtitle2" color="white">
                    Scan for direct payments
                  </Typography>
                </Box>
              )}
            </Container>
          </Box>
          {/* </Drawer> */}
        </DialogContent>
      </Dialog>
    </Box>
  );
}

export default PayProducts;
